import React, {useState} from "react";
import {ThankYouMessage} from "./thank-you-message";
import {PreAssessmentFormWizard} from "./pre-assessment-form-wizard";

export const PreAssessmentForm = () => {
    const [ isSubmitted, setIsSubmitted ] = useState(false);

    if (isSubmitted) return <ThankYouMessage />;

    return (
        <div  className='wizardContainer'>
            <h1><span className='text-orange'>Cloudnexa</span> Preassessment</h1>
            <p className='wizardDescription'>
                Need to modernize and secure your environment by moving to AWS? Complete Cloudnexa's Preassessment below and
                you may receive up to $60K in assessment funding for your entire cloud assessment journey!
            </p>

            <PreAssessmentFormWizard onSubmitted={(payload) => setIsSubmitted(payload)} />


        </div>
    );
}
